import React from 'react';
import { Grid } from '@material-ui/core';
// import AuthBanner from '../../../assets/images/authbanner.png';
import amazonverified_badge from '../../../assets/images/amazonverified_badge.png';
// import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

function RightContent() {
  return (
    <Grid item lg={12} md={12} sm={12} xs={12} className="auth_view_bg_amz">
      <div className="slogan-container slogan-image-holder ">
        <div className="slogan-center" style={{ marginBottom: '0' }}>
          {/* <div className="slogan-sm-offer">
            <div className="slogan-sm-offer-single" style={{ color: '#344054' }}>
              <CheckCircleOutlineRoundedIcon />
              <div>2 months FREE Ads Management service.</div>
            </div>
            <div className="slogan-sm-offer-single" style={{ color: '#344054' }}>
              <CheckCircleOutlineRoundedIcon />
              <div>Expert Ads Optimization.</div>
            </div>
            <div className="slogan-sm-offer-single" style={{ color: '#344054' }}>
              <CheckCircleOutlineRoundedIcon />
              <div> Account Manager Support.</div>
            </div>
            <div className="slogan-sm-offer-single" style={{ color: '#344054' }}>
              <CheckCircleOutlineRoundedIcon />
              <div>Save 90% time with automation.</div>
            </div>
          </div> */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="amazonVerified_widget_amz">
              <div>Amazon Verified Partner</div>
              <div style={{ display: 'flex' }}>
                <img src={amazonverified_badge} style={{ width: '98px' }} />
              </div>
            </div>
          </div>
          <div className="stats_widget_amz">
            <div className="stats_widget_single_amz">
              <div className="stats_widget_number" style={{ color: '#344054' }}>
                1M+
              </div>
              <div className="stats_widget_text" style={{ color: '#344054' }}>
                Bids Optimized
              </div>
            </div>
            <div className="stats_widget_single_amz stats_widget_center_amz">
              <div className="stats_widget_number" style={{ color: '#344054' }}>
                200M+
              </div>
              <div className="stats_widget_text" style={{ color: '#344054' }}>
                Total Revenue
              </div>
            </div>
            <div className="stats_widget_single_amz">
              <div className="stats_widget_number" style={{ color: '#344054' }}>
                200K+
              </div>
              <div className="stats_widget_text" style={{ color: '#344054' }}>
                Campaigns
              </div>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
}
export default RightContent;
